import CitySEOHead from "@/components/feature/CitySEOHead";
import AnkenyHeroSection from "./components/HeroSection";
import AnkenyStickyNav from "./components/StickyNav";
import AnkenyProcessingTimeSection from "./components/ProcessingTimeSection";
import AnkenyServicesSection from "./components/ServicesSection";
import AnkenyLocalAreaSection from "./components/LocalAreaSection";
import AnkenyTestimonialsSection from "./components/TestimonialsSection";
import AnkenyAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AnkenyComparisonSection from "./components/ComparisonSection";
import AnkenyMistakesSection from "./components/MistakesSection";
import AnkenyHowItWorksSection from "./components/HowItWorksSection";
import AnkenyFAQSection, { faqs } from "./components/FAQSection";
import AnkenyHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AnkenyFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const ankenyFaqs = faqs as { q: string; a: string }[];

const ankenyServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function AnkenyPage() {
  return (
    <>
      <CitySEOHead
        city="Ankeny"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/ankeny"
        title="Emergency Passport Ankeny, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Ankeny, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving manufacturing professionals, DMACC students, and growing Polk County families."
        geoPlacename="Ankeny, Iowa"
        geoPosition="41.7318;-93.6044"
        faqs={ankenyFaqs}
        servicesSchema={ankenyServices}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
      />
      <div className="font-sans">
        <AnkenyHeroSection />
        <AnkenyStickyNav />
        <AnkenyProcessingTimeSection />
        <AnkenyServicesSection />
        <AnkenyLocalAreaSection />
        <AnkenyTestimonialsSection />
        <AnkenyAcceptanceFacilitiesSection />
        <AnkenyComparisonSection />
        <AnkenyMistakesSection />
        <AnkenyHowItWorksSection />
        <AnkenyFAQSection />
        <AnkenyHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/ankeny" state="IA" />
        <AnkenyFinalCTA />
      </div>
    </>
  );
}